import api from "@rentiohq/shared-frontend/dist/utils/api/api.utils";
import { ISendToOwnerPayload } from "./sendToOwner.utils";

export interface IOwnerRecipient {
  accountId: number;
  name: string;
  hasEmail: boolean;
}

export interface ISendToOwnerResult {
  recipients: number;
  shares: number;
  applicationsWithoutPdf: string[];
}

/**
 * The owners of this property, with and without an email address.
 *
 * The ones without are returned too, and shown as not selectable with the
 * reason, because "this owner is here but cannot be mailed" is something a
 * broker has to be able to see. Leaving them out would look like the owner
 * was never added.
 */
export const getOwnerRecipients = async (propertyId: number) => {
  const response = await api.get<{ data?: IOwnerRecipient[] }>(
    `/properties/${propertyId}/owner-recipients`,
    { isV2: true },
  );

  return response.data?.data || [];
};

export const sendApplicationsToOwner = async (payload: ISendToOwnerPayload) => {
  const response = await api.post<{ data?: ISendToOwnerResult }>(
    "/applications/send-to-owner",
    { isV2: true, data: payload },
  );

  return (
    response.data?.data || {
      recipients: 0,
      shares: 0,
      applicationsWithoutPdf: [],
    }
  );
};
